export const packagePresets = [
    {
        key: 'small_bubble_mailer',
        name: 'Small Bubble Mailer',
        description: '6x9x0.5" - 1 oz',
        length: 6,
        width: 9,
        height: 0.5,
        weight: 1 / 16,
        weightUnit: 'oz',
    },
    {
        key: 'medium_bubble_mailer',
        name: 'Medium Bubble Mailer',
        description: '8.5x11x0.75" - 1 oz',
        length: 8.5,
        width: 11,
        height: 0.75,
        weight: 1 / 16,
        weightUnit: 'oz',
    },
    {
        key: 'poly_mailer',
        name: 'Poly Mailer',
        description: '10x13x0.5" - 1 oz',
        length: 10,
        width: 13,
        height: 0.5,
        weight: 1 / 16,
        weightUnit: 'oz',
    },
    {
        key: 'small_box',
        name: 'Small Box',
        description: '8x6x4" - 1 lb',
        length: 8,
        width: 6,
        height: 4,
        weight: 1,
        weightUnit: 'lbs',
    },
    {
        key: 'medium_box',
        name: 'Medium Box',
        description: '12x9x6" - 3 lbs',
        length: 12,
        width: 9,
        height: 6,
        weight: 3,
        weightUnit: 'lbs',
    },
    {
        key: 'large_box',
        name: 'Large Box',
        description: '16x12x8" - 8 lbs',
        length: 16,
        width: 12,
        height: 8,
        weight: 8,
        weightUnit: 'lbs',
    },
    {
        key: 'usps_flat_rate_box',
        name: 'USPS Flat Rate Box',
        description: '11x8.5x5.5" - 4 lbs',
        length: 11,
        width: 8.5,
        height: 5.5,
        weight: 4,
        weightUnit: 'lbs',
    },
    {
        key: 'poster_tube',
        name: 'Poster Tube',
        description: '12x3x3" - 0.5 lbs',
        length: 12,
        width: 3,
        height: 3,
        weight: 0.5,
        weightUnit: 'lbs',
    },
    {
        key: 'custom',
        name: 'Custom',
        description: 'Fill in below',
        custom: true,
    },
];

export function applyPackagePreset(preset) {
    if (!preset || preset.custom) {
        return { packagePreset: 'custom' };
    }

    return {
        length: preset.length,
        width: preset.width,
        height: preset.height,
        weight: preset.weight,
        weightUnit: preset.weightUnit || 'lbs',
        packagePreset: preset.key,
    };
}
